module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#health",
      toString: function () {
        return this.url;
      }
    }